'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Connected": "Polaris-Connected",
  "Item": "Polaris-Connected__Item",
  "Item-primary": "Polaris-Connected__Item--primary",
  "Item-focused": "Polaris-Connected__Item--focused"
};

exports.default = styles;
